// extracted by mini-css-extract-plugin
export default {"footerContainer":"UltraPDP_footerContainer__JU0Xk","timeAward":"UltraPDP_timeAward__qH34L"};